import { SERVER_URI } from '../Constant/server';
import { apiGet, apiPost, apiPut } from '../utils/axios';

const SAVE_CARD = SERVER_URI + '/add-card-price';
const GET_CARD_DATA = SERVER_URI + '/get-card-price/';
const UPDATE_CARD_DATA = SERVER_URI + '/update-card-price/';
const CARD_STATUS = SERVER_URI + '/change-status-card-price/';


export default {

  saveCard: async function (payload) {
    return apiPost(SAVE_CARD, payload)
  },

  getCardData: async function (id) {
    return apiGet(GET_CARD_DATA + id);
  },
  updateCardData: async function (id, payload) {
    //console.log("immd.....", id, payload)
    return apiPut(UPDATE_CARD_DATA + id, payload)
  },
  CardPriceStatus: async function (id) {
    return apiGet(CARD_STATUS + id);
  },
};